module.exports = __webpack_public_path__ + "media/images/front/samples-2015d5c59116dee7ac4bb2939159bf94.jpg";